// Approved copy for the "What We Do" section.
export const whatWeDo = {
  eyebrow: "WHAT WE DO",
  heading: "From Idea to Global Scale",
  support:
    "One connected apparel platform designed to move brands forward.",
  stages: [
    {
      num: "01",
      label: "IMAGINE",
      title: "Product Development",
      accent: "purple",
    },
    {
      num: "02",
      label: "CREATE",
      title: "Apparel Manufacturing",
      accent: "purple",
    },
    {
      num: "03",
      label: "CONNECT",
      title: "Supply Coordination",
      accent: "green",
    },
    {
      num: "04",
      label: "SCALE",
      title: "Brand Scale Support",
      accent: "green",
    },
  ],
  closing: "Apparel is complex. Progress should not be.",
  signature: "Build. Brand. Scale with NYLE.",
  ribbonImage:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_web-launch-512/artifacts/ir2od8qh_ChatGPT%20Image%20Aug%207%2C%202026%2C%2005_33_08%20PM.png",
};
